import React from 'react';
import { Slide, Snackbar, makeStyles } from '@material-ui/core';
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone';
import CloseIcon from '@material-ui/icons/Close';
import { Flex, BoxV2 as Box } from 'portal-commons';

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}

interface ElectCnpAlertProps {
  open: boolean;
  onClose: () => void;
}

const useStyles = makeStyles(() => ({
  snackbar: {
    top: '237px',
    right: 0,
    '& .MuiPaper-root': {
      background: '#00797C',
      padding: '15px',
      borderRadius: '14px 0 0 14px',
      width: '300px',
      boxSizing: 'border-box',
      '& .MuiSnackbarContent-message': {
        padding: 0,
        width: '100%',
      },
    },
  },
  alertIcon: {
    color: 'white',
    transform: 'rotate(15deg)',
    fontSize: '26px',
  },
  closeIcon: {
    cursor: 'pointer',
    fontSize: '20px',
    position: 'absolute',
    opacity: 0.5,
    right: '3px',
    top: '-7px',
  },
}));

export default function ElectCNPAlert({ open, onClose }: ElectCnpAlertProps) {
  const classes = useStyles();
  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={open}
      onClose={onClose}
      classes={{ root: classes.snackbar }}
      data-testid="electCnpAlert"
      message={
        <Flex
          data-testid="electCnpAlertNotification"
          sx={{
            alignItems: 'center',
            gap: 'm',
            backgroundColor: 't.turquoise600',
            borderRadius: '4px',
            minWidth: 'fit-content',
            position: 'relative',
          }}
        >
          <NotificationsNoneIcon className={classes.alertIcon} />
          <Flex sx={{ flexDirection: 'column', flex: 1 }}>
            <Box
              as="h3"
              sx={{
                color: 'white',
                fontSize: 'H400',
                fontWeight: 600,
                margin: 0,
                marginBottom: '4px',
              }}
            >
              Reminder!
            </Box>
            <Box
              as="p"
              sx={{
                color: 'white',
                margin: 0,
                fontSize: 'H200',
              }}
            >
              Please elect a new Connectivity Partner.
            </Box>
          </Flex>
          <CloseIcon
            onClick={onClose}
            className={classes.closeIcon}
            data-testid="electCnpAlertNotificationCloseButton"
          />
        </Flex>
      }
      TransitionComponent={SlideTransition}
    />
  );
}
